export const navigateTo = (history: any, path: string) => {
  history.replace(path);
};
